import { EUserStatus } from './userStatus';

export type TGeneralRating = {
  value: number;
};
export type TEcologyRating = {
  value: number;
};
export type TInfrastructureRating = {
  value: number;
};
export type TTransportRating = {
  value: number;
};
export type TPriceAndQualityBalanceRating = {
  value: number;
};
export type TUserStatusRating = {
  value: EUserStatus;
};
export type TProsRating = {
  value: string | null;
};
export type TConsRating = {
  value: string | null;
};
export type TName = {
  value: string | null;
};

export type TIsAnonymous = {
  value: boolean | null;
};

export enum ENewReviewModalStep {
  Rating = 'rating',
  Review = 'review',
  Success = 'success',
  Error = 'error',
}

export interface INewReview {
  meta: {
    open: boolean;
    step: ENewReviewModalStep;
    reviewAllowed: boolean;
  };
  data: {
    generalRating: TGeneralRating;
    ecologyRating: TEcologyRating;
    infrastructureRating: TInfrastructureRating;
    priceAndQualityBalanceRating: TPriceAndQualityBalanceRating;
    transportRating: TTransportRating;
    name: TName;
    userStatus: TUserStatusRating;
    pros: TProsRating;
    cons: TConsRating;
    isAnonymous: TIsAnonymous;
  };
}
